import React, {Component} from 'react'
import ProjectSupplierInvoiceList from "./ProjectSupplierInvoiceList"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Button} from 'reactstrap'
import {Mutation} from 'react-apollo'

import {
    checkPermission,
    PROJECTS_CAN_CREATE_SUPPLIER_BUDGETS,
    PROJECTS_CAN_EDIT_SUPPLIER_BUDGETS,
    PROJECTS_CAN_DOWNLOAD_SUPPLIER_BUDGET_FILE,
    PROJECTS_CAN_REMOVE_SUPPLIER_BUDGETS
} from "../../../lib/permissions"
import ProjectSupplierInvoiceInput from "./ProjectSupplierInvoiceInput"
import editProjectLocalMutation from '../../../queries/client_side/mutations/edit_project'
import {toast} from "react-toastify";
import ProjectSupplierInvoiceModal from "./ProjectSupplierInvoiceModal";


export default class ProjectSupplierInvoices extends Component {

    state = {
        showInput: false,
        showEdit: false,
        invoiceID: null
    }

    toggle = () => {
        this.setState({showInput: !this.state.showInput})
    }

    toggleEdit = () => {
        this.setState({showEdit: !this.state.showEdit})
    }

    render() {

        const {toggle} = this
        const {project_id, invoices, project} = this.props
        const {showInput} = this.state

        console.log('props', this.props)

        return (
            <Mutation mutation={editProjectLocalMutation}>
                {(editProjectLocalMutationFunc) => (<div>
                        <Button
                            size="sm"
                            color={showInput ? 'warning' : 'success'}
                            disabled={!checkPermission(PROJECTS_CAN_CREATE_SUPPLIER_BUDGETS)}
                            onClick={this.toggle}
                        >
                            <FontAwesomeIcon color="#fff" icon={showInput ? 'minus' : 'plus'}/>{' '}
                            {showInput ? 'Cancel' : 'Add Supplier Budget Allocation'}
                        </Button>
                        <ProjectSupplierInvoiceList
                            canDownload={checkPermission(PROJECTS_CAN_DOWNLOAD_SUPPLIER_BUDGET_FILE)}
                            canRemove={checkPermission(PROJECTS_CAN_REMOVE_SUPPLIER_BUDGETS)}
                            canEdit={checkPermission(PROJECTS_CAN_EDIT_SUPPLIER_BUDGETS)}
                            project_id={project_id}
                            invoices={invoices}
                            onEdit={(invoiceID) => {
                                this.setState({invoiceID})
                                this.toggleEdit()
                            }}
                        />


                        <ProjectSupplierInvoiceInput
                            toggle={toggle}
                            onSave={(data) => {
                                console.log('save', data)
                                editProjectLocalMutationFunc({variables: {data}})
                                toast.success('Invoice Created', {autoClose: 2000})
                                this.toggle()
                            }}
                            project_id={project_id}
                            isOpen={showInput}
                        />


                        <ProjectSupplierInvoiceModal
                            isOpen={this.state.showEdit}
                            toggle={this.toggleEdit}
                            onSave={(data) => {
                                editProjectLocalMutationFunc({variables: {data}})
                                this.toggleEdit()
                            }}
                            invoiceID={this.state.invoiceID}
                        />
                    </div>
                )}

            </Mutation>

        )
    }

}